import { createContext, useContext, useState } from 'react';

// Create the context
const JobSearchContext = createContext(null);

// Provider component
export function JobSearchProvider({ children }) {
    const [lastSearch, setLastSearch] = useState(null);

    const value = {
        lastSearch,
        setLastSearch
    };

    return (
        <JobSearchContext.Provider value={value}>
            {children}
        </JobSearchContext.Provider>
    );
}

// Hook to use the context easily
export function useJobSearch() {
    const context = useContext(JobSearchContext);
    if (!context) {
        throw new Error('useJobSearch must be used within a JobSearchProvider');
    }
    return context;
}